/**
 * @generated SignedSource<<b5e974b21b7e68b162e9c434802c0e2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelSearchSelect_data$data = {
  readonly hotelSearch?: ReadonlyArray<{
    readonly externalId: string | null;
    readonly internalId: string | null;
    readonly name: string;
  }>;
  readonly " $fragmentType": "HotelSearchSelect_data";
};
export type HotelSearchSelect_data$key = {
  readonly " $data"?: HotelSearchSelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelSearchSelect_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "searching"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./HotelSearchSelectRefetchQuery.graphql')
    }
  },
  "name": "HotelSearchSelect_data",
  "selections": [
    {
      "condition": "searching",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "search",
              "variableName": "search"
            }
          ],
          "concreteType": "HotelSearchResult",
          "kind": "LinkedField",
          "name": "hotelSearch",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "internalId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "externalId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "99397e1a1d4e75208a234a55d4844245";

export default node;
